import React from "react";

const Home: React.FC = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Vítejte!</h1>
      <p>Tato stánka vznikla jako reakce na dechberoucí rozpor mezi recenzemi na e-shop euzelva.cz a zkušeností našá a jiných lidí.</p>
      <p>Na Google či Seznamu se dozvíte vetšinou nekritické názory zákazníků, kteří si patrně želvu čerstvě převzali a, stejně jako v našem případě, ještě neměli možnost plně zkontrolovat její zdraví.</p>
      <p>Při dalším pátrání, jak na sociálních sítí, popřípadě v podobě konzultací s veterinářem se dozvíte, že želvy od Pana Junka z euzelva.cz se mohou potýkat s problémy, které byste nečekali, jsou čipovány v rozporu s doporučeními veterinářů apod. Navíc se dá říct, že v komunitě chovatelů a veterinářů je toto známá věc.</p>
      <p>Naším cílem je tedy zvýšit veřejné povědomí o tomto problému a pomoci zákazníkům při výběru vhodného chovatele.</p>
      <p>Pokud máte své zkušenosti, dobré, či špatné, můžete se s námi o ně podělit přes <a href="/kontakt">kontaktní email</a>.</p>
      <p>Nasbírané informace budou postupně zveřejněny, samozřejmě za předpokladu, že s tím bude vysloven souhlas.</p>
    </div>
  );
};

export default Home;
